
import { WindowService, IWindowOption, WindowType } from "./window/window.service";

export class FormService {

	public windowService: WindowService;
	public $translate: ng.translate.ITranslateService;

	public static $inject: Array<string> = ["WindowService", "$translate"];
	constructor(WindowService: WindowService, $translate: ng.translate.ITranslateService) {
		this.windowService = WindowService;
		this.$translate = $translate;
	}

	public CheckDirty(form: ng.IFormController, callback: Function) {
		if (form && form.$dirty) {
			this.windowService.showConfirmWindow({
				OkCallBack: callback,
				OkText: this.$translate.instant("BUTTON.CONTINUE"),
				Title: this.$translate.instant("TEXT.UNSAVEDCHANGES"),
				TextContent: this.$translate.instant("TEXT.UNSAVEDCHANGESNOTE"),
			} as IWindowOption); 
		} else {
			callback && callback()
		}
	}
}